const $ = require('jquery/dist/jquery');
require('corejs-typeahead/dist/typeahead.jquery');
const getConfiguration = require('./config');

const setValue = (instance, propertiesToSelect, selectedElement) => {
    const autocompleteInstance = instance;
    if (propertiesToSelect) {
        autocompleteInstance.content = selectedElement[propertiesToSelect.content];
        autocompleteInstance.value = selectedElement[propertiesToSelect.value];
        autocompleteInstance.kind = selectedElement[propertiesToSelect.type] || false;

        if (selectedElement[propertiesToSelect.latlon]) {
            autocompleteInstance.latitude = selectedElement[propertiesToSelect.latlon].split(',')[0].trim();
            autocompleteInstance.longitude = selectedElement[propertiesToSelect.latlon].split(',')[1].trim();
        }

        autocompleteInstance.element.dataset.content = autocompleteInstance.content;
        autocompleteInstance.element.dataset.value = autocompleteInstance.value;

        if (autocompleteInstance.kind) autocompleteInstance.element.dataset.kind = autocompleteInstance.kind;
        if (autocompleteInstance.latitude && autocompleteInstance.longitude) {
            autocompleteInstance.element.dataset.latitude = autocompleteInstance.latitude;
            autocompleteInstance.element.dataset.longitude = autocompleteInstance.longitude;
        }
    }
};

module.exports = {
    // Has Error
    hasError: function fn() {
        return this.error;
    },
    // Set valid
    setValid: function fn() {
        this.element.classList.remove(this.config.cssError);
        this.element.classList.add(this.config.cssValid);

        this.input.setValid();

        // Set validation to state
        this.error = false;

        return this;
    },
    // Set error
    setError: function fn() {
        this.element.classList.remove(this.config.cssValid);
        this.element.classList.add(this.config.cssError);

        this.input.setError();

        // Set error to state
        this.error = true;

        return this;
    },
    // Get autocomplete configuration
    getConfig: function fn() {
        if (this.element) {
            if (this.element.dataset.config) {
                const config = JSON.parse(this.element.dataset.config);

                this.element.dataset.config = '';

                const providerFromConfig = { ...config.provider };
                const internalConfiguration = getConfiguration(providerFromConfig.name);
                const parameters = { ...internalConfiguration.provider.parameters, ...providerFromConfig.parameters };

                return {
                    ...internalConfiguration,
                    ...config,
                    provider: { ...internalConfiguration.provider, ...providerFromConfig, ...{ parameters } }
                };
            }
        }
        return getConfiguration();
    },
    // Initialize autocomplete core
    initialize: function fn() {
        const datasets = this.config.provider.configure(this.element, this.config.lang, this.config.autocomplete);

        this.suggestions = datasets[0].source;

        this.suggestions
            .initialize()
            .done(() => {
                $(this.input.getInput())
                    .typeahead({ ...this.config.provider.options }, datasets)
                    .bind('typeahead:select', (ev, suggestion) => {
                        const providerEngine = this.config.provider;

                        this.input.onChange(ev);

                        setValue(this, providerEngine.propertiesToSelect, providerEngine.transform(suggestion));

                        if (this.config.onChange.length > 0) this.config.onChange.forEach(item => item(this, ev));

                        ev.stopPropagation();
                    });
            })
            .fail(() => {
                console.error('<autocomplete>: Failed loading configuration :(');
            })
            .then(() => {
                const dataset = this.element.dataset || {};
                this.set({ content: dataset.content || false, value: dataset.value, type: dataset.kind || false });

                // Set our input to active in case we have a default init value
                if (this.content) this.input.setActive();
            });

        return this;
    },
    // Get autcomplete value
    get: function fn() {
        let value = {};
        if (this.content && this.value) {
            value = {
                code: this.value,
                content: this.content,
                type: this.kind
            };

            if (this.longitude && this.latitude) {
                return {
                    ...value,
                    latitude: this.latitude,
                    longitude: this.longitude
                };
            }
        }
        return value;
    },
    // Set autocomplete value
    set: function fn(value = {}) {
        if (value.content) {
            $(this.input.getInput()).typeahead('val', value.content);

            setValue(this, this.config.provider.propertiesToSelect, value);
        }
        return this;
    }
};
